import React from 'react';

import Header from '../../components/Header';
import Title from '../../components/Title';
import Text from '../../components/Text';
import Line from '../../components/Line';
import List from '../../components/List';
import Actions from '../../components/Actions';
import CostRevenueRevenueCard from './CostRevenueRevenueCard';
import MobileMenuHeader from '../../components/MobileMenuHeader';

export default function RevenueIntro(props) {
  const {
    nextClickHandler,
    menuItems,
    selectComponent,
    componentIndex,
    rules,
    backPath,
    locales,
    locales: {
      common,
      tipCustomerSegment,
      costRevenue: {
        name,
        revenueIntro: { header, title, text, list, card },
      },
    },
  } = props;

  return (
    <section className="bmc-page" aria-label={header}>
      <Header
        title={header}
        subtitle={name}
        icon="icon-revenue"
        locales={locales}
        componentIndex={componentIndex}
        className="bmc-page-header--violet"
        tipLocales={tipCustomerSegment}
        menuItems={menuItems}
        onMenuItemClick={selectComponent}
        rules={rules}
        backPath={backPath}
        mobileMenuHeader={
          <MobileMenuHeader icon="FinanceCanvas" title={name} color="violet" />
        }
      />

      <Text>{[text[0], text[1], text[2], text[3]]}</Text>

      <Title text={title[0]} align="left" />

      <List items={list} />

      <Line />

      <Title text={title[1]} className="margin-top-60" />

      <Text>{[text[4]]}</Text>

      <CostRevenueRevenueCard
        card={card}
        className="margin-top-60 margin-wide-40-lg"
        locales={locales}
      />

      <Actions nextClickHandler={nextClickHandler} buttonName={common.next} />
    </section>
  );
}
